import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { defaultContext, getInitialStyle, PADDING } from './stamp.style';

export default class Stamp extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _build() {
    const label = this.tag('Label');

    const handleUpdate = () => {
      const w = label.finalW + PADDING[this._style.screenSize] * 2;
      const labelOffsetX = (w - label.finalW) / 2;

      this.patch({
        w,
        Label: {
          x: labelOffsetX,
        },
      });

      this.emit('txLoaded');
    };

    label.on('txLoaded', handleUpdate);
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  set labelColor(value) {
    this.tag('Label').color = value;
  }

  set backgroundColor(value) {
    this.tag('Background').color = value;
  }

  set wordWrapWidth(value) {
    this.tag('Label').text.wordWrapWidth = value;
  }
}
